import PropTypes from 'prop-types'
import { Component } from 'react'
import ImmutableTypes from 'react-immutable-proptypes'
import _filter from 'lodash/filter'
import SimpleSelect from 'components/shared/SimpleSelect'
import IconSVG from 'svg-inline-react'
import { Select } from '@driftt/tide-core-legacy'

const IS_NOT = "isn't any of"
const IS = "is any of"

export const OrNode = (
  <div className="dsg-Label--gray flex" style={{ alignItems: 'center', justifyContent: 'flex-end' }}>
    Or
  </div>
)

function Icon({ onClick, src }) {
  return (
    <div onClick={ onClick } style={{ padding: 3 }}>
      <IconSVG
        style={{ width: 10, height: 10, cursor: "pointer" }}
        element="div"
        className="gray-icon"
        src={ src }
      />
    </div>
  )
}

export function AddIcon({ onClick }) {
  return (
    <Icon
      onClick={ onClick }
      src={ PlusSvgSrc }
    />
  )
}

export function RemoveIcon({ onClick }) {
  return (
    <Icon
      onClick={ onClick }
      src={ CrossSvgSrc }
    />
  )
}

export const PlusSvgSrc = require('!svg-inline?removeTags=true!images/svg/plus.svg')
export const CrossSvgSrc = require('!svg-inline?removeTags=true!images/icons/times-icon.svg')

class IsAnyOfInputs extends Component {
  static propTypes = {
    conditionUpdater: PropTypes.func,
    conditionValue: ImmutableTypes.map,
    // TODO create static type for SimpleSelectOption and use it here
    options: PropTypes.arrayOf(PropTypes.object)
  }

  state = {
    options: this.props.options
  }

  onOperatorSelect(operator) {
    this.props.conditionUpdater('operator', operator)
  }

  makeOnOptionSelect(index) {
    return (option) => {
      const options = this.props.conditionValue.get('value')
      this.props.conditionUpdater('value', options.set(index, option.value))
    }
  }

  makeOnRemove(index) {
    return () => {
      const options = this.props.conditionValue.get('value')
      this.props.conditionUpdater('value', options.splice(index, 1))
    }
  }

  onAddOptionSelect() {
    const availableOptions = this.getAvailableOptions()
    if (!availableOptions || !availableOptions.length) return
    const firstOptionValue = availableOptions[0].value
    const options = this.props.conditionValue.get('value')
    this.props.conditionUpdater('value', options.push(firstOptionValue))
  }

  /**
   * get options that are not selected
   * @returns {Array}
   */
  getAvailableOptions() {
    const options = this.props.conditionValue.get('value')
    return _filter(this.state.options, ({ value }) => {
      const found = options.find((option) => {
        return option === value
      })
      return !found
    })
  }

  optionCreator = ({ label }) => {
    return { label, value: label }
  }

  handleCreateOption = (index) => {
    return (option) => {
      const options = [...this.state.options, option]
      this.setState({ options },
        this.makeOnOptionSelect(index)(option)
      )
    }
  }

  renderAddIcon() {
    const availableOptions = this.getAvailableOptions()
    return (
      <AddIcon
        onClick={ availableOptions.length ? this.onAddOptionSelect.bind(this) : null }
      />
    )
  }

  renderRemoveIcon(index) {
    return (
      <RemoveIcon
        onClick={ this.makeOnRemove(index) }
      />
    )
  }

  renderSelect = () => {
    const options = this.props.conditionValue.get('value')
    const isCreatable = this.props.isCreatable || false
    return options.map((option, index, { size }) => {
      let actionButton
      if (index === 0) {
        actionButton = this.renderAddIcon()
      } else {
        actionButton = this.renderRemoveIcon(index)
      }
      const node = [
        <Select
          value={option}
          options={this.state.options}
          onChange={this.makeOnOptionSelect(index)}
          clearable={false}
          creatable={isCreatable}
          newOptionCreator={this.optionCreator}
          onNewOptionClick={this.handleCreateOption(index)}
          placeholder={this.props.placeholder}
        />,
        actionButton
      ]
      if (index !== size - 1) {
        node.push(OrNode)
      }
      return node
    })
  }

  render() {
    const { conditionValue } = this.props
    const isAnyOf = conditionValue.get('operator') === 'isAnyOf'
    return (
      <div className="flex-space-around flex-2 flex-wrap">
        <SimpleSelect
          onSelection={ this.onOperatorSelect.bind(this) }
          options={ [isAnyOf ? { value: 'notIsAnyOf', text: IS_NOT } : { value: 'isAnyOf', text: IS }] }
          selectedValue={ isAnyOf ? IS : IS_NOT }
        />
        { this.renderSelect() }
      </div>
    )
  }
}

export default IsAnyOfInputs



// WEBPACK FOOTER //
// ./src/scripts/components/CampaignWizards/TargetingInputArea/TargetConditionInput/TargetConditionEditModal/IsAnyOfInputs.js